import { Flex } from "antd";
import "./project-list.scss";
import { LegacyApi, ModernApi } from "@entities/api";
import { ProjectCard } from "./ui/project-card";

interface ProjectListProps {
  projects: Array<ModernApi.ProjectCardDto | LegacyApi.ProjectCardDto>;
  mode: "modern" | "legacy";
}

export const ProjectList = ({ projects, mode }: ProjectListProps) => {
  return (
    <Flex
      component="main"
      className="project-screen"
      vertical
      justify="space-between"
    >
      <div className="project-grid">
        {projects?.map((project) => (
          <ProjectCard key={project.projectId} project={project} mode={mode} />
        ))}
      </div>
    </Flex>
  );
};
